// extracted by mini-css-extract-plugin
export default {"wrapper":"ContentTypeVideo_wrapper__1fNDs","placeholder":"ContentTypeVideo_placeholder__2OPxu","clickable":"ContentTypeVideo_clickable__mxebc"};